<template>
  <div class="py-8">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link class="text-decoration--none" :to="{ name: 'exercises' }"
          >Exercise</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4">
      <div class="align-center d-flex justify-space-between">
        <div class="display-1 font-weight-bold my-6 text-capitalize">
          Update Exercise
        </div>
        <template v-if="!loading"> </template>
      </div>

      <div class="col-xl-4 col-lg-6 col-md-12 mt-6 pa-0">
        <v-form v-if="form" @submit.prevent="submit" ref="form" v-model="valid">
          <v-divider class="pb-5"></v-divider>

          <label class="text-field-label">Name</label>
          <v-text-field
            flat
            solo
            required
            counter
            :rules="rules.name"
            class="mt-2"
            maxlength="255"
            v-model="form.name"
            placeholder="Name"
            :error-messages="form.$getError('name')"
          ></v-text-field>

          <label class="text-field-label">Description</label>
          <v-textarea
            solo
            maxlength="255"
            name="input-7-4"
            v-model="form.description"
            placeholder="Description"
            :error-messages="form.$getError('description')"
          ></v-textarea>

          <label class="text-field-label">Type</label>
          <v-select
            flat
            solo
            required
            class="mt-2"
            v-model="form.effort_type"
            placeholder="Type"
            :rules="rules.effort_type"
            :items="type_options"
            :error-messages="form.$getError('effort_type')"
          ></v-select>

          <label class="text-field-label">Exercise Categories</label>
          <v-select
            flat
            solo
            class="mt-2"
            aspect-ratio="1"
            :items="exercise_category_details"
            item-text="label"
            item-value="value"
            placeholder="Select Exercise Categories"
            v-model="form.exercise_category_ids"
            multiple
            chips
          ></v-select>

          <label class="text-field-label">Equipments</label>
          <v-select
            flat
            solo
            v-model="form.equipment_ids"
            :items="equipments_details"
            item-text="label"
            item-value="value"
            multiple
            chips
            placeholder="Select Equipments"
            persistent-hint
          ></v-select>

          <label class="text-field-label">Beginner Reps</label>
          <div class="d-flex mb-4">
            <v-text-field
              flat
              solo
              required
              counter
              :rules="rules.name"
              class="mt-2"
              maxlength="255"
              v-model="form.exercise_levels.beginner"
              placeholder="Beginner Reps"
              type="number"
            ></v-text-field>
          </div>

          <label class="text-field-label">Intermediate Reps</label>
          <div class="d-flex mb-4">
            <v-text-field
              flat
              solo
              required
              counter
              :rules="rules.name"
              class="mt-2"
              maxlength="255"
              v-model="form.exercise_levels.intermediate"
              placeholder="Intermediate Reps"
              type="number"
            ></v-text-field>
          </div>

          <label class="text-field-label">Advanced Reps</label>
          <div class="d-flex mb-4">
            <v-text-field
              flat
              solo
              required
              counter
              :rules="rules.name"
              class="mt-2"
              maxlength="255"
              v-model="form.exercise_levels.advanced"
              placeholder="Advanced Reps"
              type="number"
            ></v-text-field>
          </div>

          <label class="text-field-label">Right Intro Video</label>
          <v-autocomplete
            flat
            solo
            class="mt-2"
            aspect-ratio="1"
            :items="video_details"
            item-text="label"
            item-value="value"
            placeholder="Select Right Intro Video"
            v-model="form.videos.right_intro"
          ></v-autocomplete>

          <label class="text-field-label">Right Exercise Video</label>
          <v-autocomplete
            flat
            solo
            class="mt-2"
            aspect-ratio="1"
            :items="video_details"
            item-text="label"
            item-value="value"
            placeholder="Select Right Exercise Video"
            v-model="form.videos.right_exercise"
          ></v-autocomplete>

          <label class="text-field-label">Left Intro Video</label>
          <v-autocomplete
            flat
            solo
            class="mt-2"
            aspect-ratio="1"
            :items="video_details"
            item-text="label"
            item-value="value"
            placeholder="Select Left Intro Video"
            v-model="form.videos.left_intro"
          ></v-autocomplete>

          <label class="text-field-label">Left Exercise Video</label>
          <v-autocomplete
            flat
            solo
            class="mt-2"
            aspect-ratio="1"
            :items="video_details"
            item-text="label"
            item-value="value"
            placeholder="Select Left Exercise Video"
            v-model="form.videos.left_exercise"
          ></v-autocomplete>

          <label class="text-field-label">Thumbnail</label>
          <v-file-input
            accept="image/png, image/jpeg, image/bmp"
            placeholder="Pick a photo"
            :prepend-icon="icons.camera"
            v-model="form.photo"
            :error-messages="form.$getError('photo')"
          ></v-file-input>

          <div class="mt-4">
            <v-btn
              color="primary"
              class="mr-4 px-6"
              height="40px"
              width="70%"
              @click="submit"
              :loading="form.$busy"
              ><v-icon left dark> {{ icons.update }} </v-icon>Update</v-btn
            >
          </div>
          <div class="mt-4">
            <v-btn
              @click="showDeleteModal = true"
              height="40px"
              width="70%"
              color="error"
              ><v-icon left dark> {{ icons.remove }} </v-icon>Delete
              Exercise</v-btn
            >
          </div>
        </v-form>
      </div>
    </div>
    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text @click="snackbar.show = false" v-bind="attrs">OK</v-btn>
      </template>
    </v-snackbar>

    <ConfirmModal
      v-model="showDeleteModal"
      title="Delete Exercise"
      message="Are you sure you want to delete exercise?"
      @cancel="showDeleteModal = false"
      @confirm="removeExercise"
    ></ConfirmModal>
  </div>
</template>

<script>
import Form from '@/utils/form'
import { mdiChevronLeft, mdiTrashCan, mdiUpdate, mdiCamera } from '@mdi/js'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import { mapActions, mapState, mapMutations } from 'vuex'
import ConfirmModal from '@/components/modals/ConfirmModal'
import { each } from 'lodash'

export default {
  name: 'ExerciseDetails',

  components: {
    AppBarNavIcon,
    ConfirmModal,
  },

  data() {
    return {
      valid: false,
      loading: false,
      form: new Form({
        name: '',
        description: '',
        effort_type: null,
        exercise_category_ids: [],
        videos: {
          right_intro: null,
          right_exercise: null,
          left_intro: null,
          left_exercise: null,
        },
        exercise_levels: {
          beginner: null,
          intermediate: null,
          advanced: null,
        },
        photo: null,
        equipment_ids: [],
      }),
      photoCover: null,
      showDeleteModal: false,
      type_options: ['reps', 'duration'],
      exercise_items: [],
      video_details: [],
      exercise_category_details: [],
      equipments_details: [],
      icons: {
        arrowLeft: mdiChevronLeft,
        remove: mdiTrashCan,
        update: mdiUpdate,
        camera: mdiCamera,
      },
      rules: {
        name: [(v) => !!v || 'Name is required'],
        effort_type: [(v) => !!v || 'Type is required'],
      },
      snackbar: {
        show: false,
        message: null,
        color: '',
      },
    }
  },

  computed: {
    ...mapState({
      exerciseDetails: (state) => state.exercise.exerciseDetails,
      exerciseItemCategory: (state) => state.exercise.exerciseItemCategory,
      video: (state) => state.video.list,
      equipments: (state) => state.exercise.equipments,
    }),
  },

  methods: {
    ...mapActions({
      updateExercise: 'exercise/updateExercise',
      getExerciseDetails: 'exercise/getExerciseDetails',
      deleteExercise: 'exercise/deleteExercise',
      getExerciseItemCategory: 'exercise/getExerciseItemCategory',
      getVideos: 'video/getVideos',
      getEquipments: 'exercise/getEquipments',
    }),

    ...mapMutations({
      clearExerciseDetails: 'exercise/clearExerciseDetails',
    }),

    async getExerciseItemsCategory() {
      this.loading = true
      await this.getExerciseItemCategory()
      each(this.exerciseItemCategory.exercise_category, (value, key) => {
        this.exercise_category_details.push({
          label: value.category_name,
          value: value.id,
        })
      })

      each(this.exerciseItemCategory.exercise_items, (value, key) => {
        this.exercise_items.push({
          label: value.name,
          value: value.id,
        })
      })
      this.loading = false
    },

    async getEquipmentsDetails() {
      await this.getEquipments()
      each(this.equipments, (value, key) => {
        this.equipments_details.push({
          label: value.name,
          value: value.id,
        })
      })
    },

    async getExercise() {
      this.loading = true
      await this.getExerciseDetails(this.$route.params.id)

      const exerciseData = this.exerciseDetails
      const { name, description, effortType, photo, categories, equipments } =
        exerciseData

      this.form.name = name
      this.form.description = description
      this.form.effort_type = effortType
      this.form.photo = photo

      // Handle levels data as array of objects
      const levels =
        exerciseData.levels ||
        exerciseData.exercise_levels ||
        exerciseData.exerciseLevels

      if (levels && Array.isArray(levels)) {
        // Find each level by the level property and extract reps
        const beginnerLevel = levels.find((level) => level.level === 'beginner')
        const intermediateLevel = levels.find(
          (level) => level.level === 'intermediate'
        )
        const advancedLevel = levels.find((level) => level.level === 'advanced')

        this.form.exercise_levels.beginner = beginnerLevel?.reps || null
        this.form.exercise_levels.intermediate = intermediateLevel?.reps || null
        this.form.exercise_levels.advanced = advancedLevel?.reps || null
      }

      // Handle videos data as array of objects
      const videos =
        exerciseData.videos || exerciseData.video || exerciseData.exerciseVideos

      if (videos && Array.isArray(videos)) {
        // Find videos by name pattern
        const rightIntroVideo = videos.find(
          (video) => video.exercise_video_type === 'right_intro'
        )
        const rightExerciseVideo = videos.find(
          (video) => video.exercise_video_type === 'right_exercise'
        )
        const leftIntroVideo = videos.find(
          (video) => video.exercise_video_type === 'left_intro'
        )
        const leftExerciseVideo = videos.find(
          (video) => video.exercise_video_type === 'left_exercise'
        )

        this.form.videos.right_intro = rightIntroVideo?.id || null
        this.form.videos.right_exercise = rightExerciseVideo?.id || null
        this.form.videos.left_intro = leftIntroVideo?.id || null
        this.form.videos.left_exercise = leftExerciseVideo?.id || null
      }

      if (categories) {
        const details = categories
        const exerciseItemsId = details.map((exerciseItem) => exerciseItem.id)
        this.form.exercise_category_ids = exerciseItemsId
      }

      if (equipments) {
        const details = equipments
        const exerciseItemsId = details.map((exerciseItem) => exerciseItem.id)
        this.form.equipment_ids = exerciseItemsId
      }
      this.loading = false
    },

    async submit() {
      this.form.$busy = true
      this.form.$clearErrors()

      const formData = new FormData()

      each(this.form.$data(), (value, key) => {
        if (key === 'photo') {
          if (value && !value.collection_name) {
            formData.append(key, value)
          }
        } else if (key === 'videos' || key === 'exercise_levels') {
          each(value, (v, k) => {
            if (v) formData.append(`${key}[${k}]`, v)
          })
        } else if (['equipment_ids', 'exercise_category_ids'].includes(key)) {
          each(value, (v, k) => {
            formData.append(`${key}[]`, v)
          })
        } else {
          formData.append(key, value)
        }
      })
      formData.append('_method', 'PUT')

      const data = {
        data: formData,
        id: this.$route.params.id,
      }

      this.updateExercise(data)
        .then(() => {
          this.showSnackbar('Exercise successfully updated!', 'success')

          setTimeout(() => {
            this.$router.push({
              name: 'exercises',
            })
          }, 1000)
        })
        .catch((err) => {
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })
        .finally(() => (this.form.$busy = false))
    },

    imageChanged(image) {
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = (e) => {
        this.photoCover = reader.result
        this.form.photo = image
      }
    },

    setExerciseItem(value) {
      this.form.exercise_items = value
    },

    async getVideoDetails(page = 1) {
      let params = {
        page,
      }

      await this.getVideos(params)
      each(this.video, (value, key) => {
        this.video_details.push({
          label: value.name,
          value: value.id,
        })
      })
    },

    removeExercise() {
      this.loading = true

      this.deleteExercise(this.$route.params.id)
        .then(() => {
          this.$router.push({ name: 'exercises' })
        })
        .catch((error) =>
          this.showSnackbar(error.response.data.message, 'error')
        )
        .finally(() => (this.loading = false))
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
  },

  async created() {
    await Promise.all([
      this.getExerciseItemsCategory(),
      this.getVideoDetails(),
      this.getEquipmentsDetails(),
    ])
    await this.getExercise()
  },

  destroyed() {
    this.clearExerciseDetails()
  },

  watch: {
    $route() {
      this.getExercise()
    },
  },
}
</script>
